import arrowLeft from './icons/icon_arrow_left.svg'
import arrowRight from './icons/icon_arrow_right.svg'
import crtLogo from './icons/icon_dtr.svg'
import searchIcon from './icons/icon_search.svg'
import printerIcon from './icons/icon_printer.svg'
import mLogo from './icons/rusroman-m.svg'

export default () => {
  document.querySelectorAll('.carousel__button--prev .carousel__icon').forEach(icon => icon.innerHTML = arrowLeft)
  document.querySelectorAll('.carousel__button--next .carousel__icon').forEach(icon => icon.innerHTML = arrowRight)

  document.querySelector('.associate--dtr .associate__logo').innerHTML = crtLogo
  document.querySelector('.header__logo--mobile .logo--mobile').innerHTML = mLogo

  document.querySelectorAll('.search__icon').forEach(icon => icon.innerHTML = searchIcon)

  document.querySelector('.footer__logo .dtr__icon').innerHTML = crtLogo

  const printer = document.querySelector('.js-print-schedule .button__icon')

  if (printer) { 
    printer.innerHTML = printerIcon
  }

  const iconPrev = document.querySelector('.pagination__icon--prev')
  const iconNext = document.querySelector('.pagination__icon--next')

  if (iconPrev) {
    iconPrev.innerHTML = arrowLeft
  }

  if (iconNext) {
    iconNext.innerHTML = arrowRight
  }
}
